<div class="card mb-3">
  <div class="card-header bg-primary text-white">Find a location</div>
  <div class="card-body table-accent-bg">
    <form [formGroup]="locationVerifyForm">
      <fieldset>
        <legend class="visually-hidden">Verify a location by address</legend>
            <label for="Address" class="form-label required-field">Search address:</label>
            <div class="row">
              <div class="col-md">
                <p-autoComplete #irtn inputId="Address" [(ngModel)]="_defaultlocation" formControlName="Address" styleClass="d-block" inputStyleClass="form-control mb-2" [suggestions]="addressSuggestions" field="text" [minLength]="4" (completeMethod)="getAddressSuggestions($event)" [tabindex]="0" appendTo="body" [required]="true" nessAutoFocus></p-autoComplete>
                <div class="invalid-feedback">
                  Please provide an address.
                </div>
              </div>
              <div class="col-md-auto"><button class="btn btn-active mb-2" type="button" [disabled]="locationVerifyForm.invalid" (click)="onVerifyAddressSubmit()">Verify address</button></div>
            </div>
      </fieldset>
    </form>
  </div>
  <div class="card-footer bg-body p-0">
    <p-table [value]="addressCandidates" [columns]="cols" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" styleClass="temp-bs" selectionMode="single" (onRowSelect)="onRowSelected($event)" [autoLayout]="true" responsiveLayout="scroll">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngFor="let col of columns">{{col.header}}</th> 
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" tabindex="0" role="button" aria-label="Select as verified address">
          <th scope="row">{{rowData.address}}</th>
          <td>{{rowData.attributes?.Addr_type}}</td>
          <td>{{rowData.score}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            No address found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
